module.exports = __webpack_public_path__ + "img/IMG_1863.8acb1587.jpg";